
import { useState } from 'react';

export default function AboutSection() {
  const [isImageEnlarged, setIsImageEnlarged] = useState(false);

  const stats = [
    { number: '10+', label: 'Years Experience' },
    { number: '100%', label: 'Nonprofit Focused' },
    { number: '24/7', label: 'Support Portal Access' },
    { number: '99.9%', label: 'Uptime Achieved' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Your Trusted IT Partner for Nonprofit Success
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              For over 10 years, we've been dedicated to empowering Virginia nonprofits with 
              reliable, secure, and cost-effective IT solutions. We understand that every dollar 
              counts in the nonprofit sector, which is why we focus on maximizing your technology 
              ROI while minimizing downtime and security risks. That's what tekFLOW is.
            </p>

            <p className="text-lg text-gray-600 mb-8">
              We specialize in nonprofit technology challenges, 
              from donor data security to volunteer management systems. We're not just your IT 
              provider – we're your technology partner committed to your mission's success.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">{stat.number}</div>
                  <div className="text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <button
                onClick={() => setIsImageEnlarged(true)}
                className="cursor-pointer hover:opacity-80 transition-opacity duration-300"
                aria-label="View partnerships and certifications in full size"
              >
                <img 
                  src="https://static.readdy.ai/image/bbcc86dc4c3a385b7f9b9f3a7e24f053/93d79932342caaa7ce013f562d27689c.png"
                  alt="Partnerships and Certifications"
                  className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="300"
                />
              </button>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/b72040b8e5716f2890799d194f8a33f8.jpg"
              alt="Our professional IT team"
              className="rounded-xl shadow-2xl object-cover w-full h-96 lg:h-full"
              loading="lazy"
              decoding="async"
              width="500"
              height="600"
            />
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-6 rounded-lg shadow-xl">
              <div className="text-2xl font-bold mb-1">Virginia Based</div>
              <div className="text-teal-100">Serving nonprofits statewide</div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Enlargement Modal */}
      {isImageEnlarged && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={() => setIsImageEnlarged(false)}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={() => setIsImageEnlarged(false)}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 text-2xl cursor-pointer"
              aria-label="Close enlarged image view"
            >
              <i className="ri-close-line"></i>
            </button>
            <img 
              src="https://static.readdy.ai/image/bbcc86dc4c3a385b7f9b9f3a7e24f053/93d79932342caaa7ce013f562d27689c.png"
              alt="Partnerships and Certifications - Enlarged"
              className="max-w-full max-h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
              width="800"
              height="600"
            />
          </div>
        </div>
      )}
    </section>
  );
}
